import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { CashPlusConfigurationsApi, CashPlusPortfolioApi, OptStatus } from "@modules/cashplus/entities/cashplus.model";
import { CashPlusTrackingFacade } from "@modules/cashplus/+state/cashplus-tracking.facade";

@Component({
	selector: "cashplus-portfolio-widget",
	templateUrl: "./cashplus-portfolio-widget.component.html",
	styleUrls: ["./cashplus-portfolio-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CashplusPortfolioWidgetComponent implements OnInit {
	@Input() public cashPlusPortfolio: CashPlusPortfolioApi = null;
	@Input() public cashPlusConfig: CashPlusConfigurationsApi = null;
	@Input() public currentRate: number = 0;
	@Input() public currencyId: string = "";

	defaultToggle = true;

	@Output() public optState: EventEmitter<string> = new EventEmitter<string>();
	@Output() public infoState: EventEmitter<string> = new EventEmitter<string>();
	@Output() public cashOut: EventEmitter<void> = new EventEmitter<void>();

	private cashPlusTrackingFacade: CashPlusTrackingFacade = inject(CashPlusTrackingFacade);
	public ngOnInit(): void {
		this.cashPlusTrackingFacade.portfolioWidgetViewed();
	}
	public onToggleClick(evt: Event): void {
		evt.stopImmediatePropagation();
		this.optState.emit(OptStatus.OptOut);
	}

	public onCashOutClick(): void {
		this.cashOut.emit();
	}

	public onInfoClick(status: string): void {
		this.infoState.emit(status);
	}
}
